import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnterVoWD, Supplier,Report, DropAmtComnt, AddUser } from '../_models';
import { environment } from '../../environments/environment';
import { ApprovedDate } from '../_models/approved-date';
@Injectable({
  providedIn: 'root'
})
export class ReportService {
  Url= environment.ApiUrl + "report";
  constructor(private http: HttpClient) { }

getSuppliers() {
  return this.http.get<Supplier[]>(`${this.Url}/getsuppliers`);
}
getObjectAcunt() {
  return this.http.get<string[]>(`${this.Url}/getobjacunt`);
}

getAccurlYrs() {
  return this.http.get<string[]>(`${this.Url}/getacurlyrs`);
}
getallusersList() {
  return this.http.get<AddUser[]>(`${this.Url}/getallusers`);
}

updateDropAnalysis(VowdInfo: any[])
  {
    return this.http.post(`${this.Url}/updatedropanalysis`,VowdInfo);
  }
  CalculateAccural(VowdInfo: any)
  {
    return this.http.post<EnterVoWD>(`${this.Url}/calculateaccural`,VowdInfo);
  }


getOpexAccrualReport(rptModel : Report) {
  return this.http.post<any[]>(`${this.Url}/viewopexaccrual`,rptModel);
}

DashboardReport(rptModel: Report)
  {
    return this.http.post(`${this.Url}/getdashboarddet`,rptModel);
  }

getAllDropAnalysisSearch(rptModel: Report) {
    return this.http.post<any>(`${this.Url}/viewdropanalysissearch`,rptModel);
}

getAllContractReportSearch(rptModel: Report) {
  return this.http.post<any>(`${this.Url}/viewContractReport`,rptModel);
}

AddDropAmtComnt(rptModel: DropAmtComnt)
  {
    return this.http.post(`${this.Url}/adddropcomnt`,rptModel);
  }

  getDropAmtComnt(rptModel : Report) {
    return this.http.post<any>(`${this.Url}/getdropamtcomnt`,rptModel);
}

getOpexAccrual(rptModel : Report) {
    return this.http.post<any[]>(`${this.Url}/getopexaccrual`,rptModel);
  }

getAgingDetails(supAB:string,objectAcc:string,apprDate:string) {
    return this.http.get<any[]>(`${this.Url}/getaging/${apprDate}/${supAB}/${objectAcc}`);
  }

dropCommentReport(rptModel : Report) {
    return this.http.post<any[]>(`${this.Url}/getdropreport`,rptModel);
  }
dropCommentUpdatedReport(rptModel : Report) {
    return this.http.post<any[]>(`${this.Url}/getupdateddropreport`,rptModel);
  }
varianceCommentReport(rptModel : Report) {
    return this.http.post<any[]>(`${this.Url}/getvariancereport`,rptModel);
  }

vowdLogReport(year : string) {
    return this.http.get<any[]>(`${this.Url}/vowdlog/${year}`);
  }

addApprovedDate(apprDate : ApprovedDate) {
    return this.http.post<any[]>(`${this.Url}/addapprdate`,apprDate);
  }

getApprovedDate() {
    return this.http.get<ApprovedDate>(`${this.Url}/getapprdate`);
  }

getPaymentDetails(rptModel: Report){
    return this.http.post<any[]>(`${this.Url}/getPaymentDetails`,rptModel);
  }
}

